import React from 'react';
import axios from "axios";
import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Artikel from './pages/Artikel';
import Contact from './pages/Contact';
import MediaPromosi from './pages/MediaPromosi';
import PanduanAplikasi from './pages/PanduanAplikasi';
import PanduanDaftarQrisku from './pages/PanduanDaftarQrisku';
import Login from './pages/Login';
import ProtectedRoute from "./components/ProtectedRoute";
import AdminLayout from "./pages/admin/AdminLayout";
import WhyUs from './pages/admin/WhyUs';
import Provider from './pages/admin/Provider';
import Product from './pages/admin/Product';
import Statistic from './pages/admin/Statistic';
import Testimoni from './pages/admin/Testimoni';
import AboutUs from './pages/admin/About';
import Gallery from './pages/admin/Gallery';
import Team from './pages/admin/Team';
import Media from './pages/admin/Media';
import Panduan from './pages/admin/Panduan';
import Article from './pages/admin/Article';
import Live from './pages/admin/Live';
import PostDetail from "./pages/PostDetail";
import ScrollToTop from "./components/ScrollToTop";
import LiveWidget from './components/LiveWidget';
import ProfileCard from "./pages/ProfileCard";
import Running from './pages/admin/Running';
import SectionHero from './pages/admin/SectionHero';
import ContactData from './pages/admin/ContactData';

function App() {

  return (
    <div className="min-h-screen bg-slate-100">      
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/artikel-kenzie-komunika" element={<Artikel />} />
        <Route path="/post/:slug" element={<PostDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/media-promosi" element={<MediaPromosi />} />
        <Route path="/panduan-aplikasi" element={<PanduanAplikasi />} />
        <Route path="/panduan-daftar-qrisku" element={<PanduanDaftarQrisku />} />
        <Route path="/login" element={<Login />} />
        {/* ADMIN AREA */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
        </Route>
        <Route
          path="/admin/whyus"
          element={
            <ProtectedRoute>
              <WhyUs/>
            </ProtectedRoute>
          }
        >
        </Route>
        <Route
          path="/admin/provider"
          element={
            <ProtectedRoute>
              <Provider/>
            </ProtectedRoute>
          }
        >
        </Route>
        <Route
          path="/admin/product"
          element={
            <ProtectedRoute>
              <Product/>
            </ProtectedRoute>
          }
        >
        </Route>
        <Route
          path="/admin/statistic"
          element={
            <ProtectedRoute>
              <Statistic/>
            </ProtectedRoute>
          }
        >
        </Route>
        <Route
          path="/admin/testimoni"
          element={
            <ProtectedRoute>
              <Testimoni/>
            </ProtectedRoute>
          }
        >
        </Route>
        <Route
          path="/admin/about"
          element={
            <ProtectedRoute>
              <AboutUs/>
            </ProtectedRoute>
          }
        >
        </Route>
        <Route
          path="/admin/gallery"
          element={
            <ProtectedRoute>
              <Gallery/>
            </ProtectedRoute>
          }
        >
        </Route>
        <Route
          path="/admin/team"
          element={
            <ProtectedRoute>
              <Team/>
            </ProtectedRoute>
          }
        >
        </Route>
        <Route
          path="/admin/media"
          element={
            <ProtectedRoute>
              <Media/>
            </ProtectedRoute>
          }
        >
        </Route>
        <Route
          path="/admin/panduan-aplikasi"
          element={
            <ProtectedRoute>
              <Panduan/>
            </ProtectedRoute>
          }
        >
        </Route>
        <Route
          path="/admin/article"
          element={
            <ProtectedRoute>
              <Article/>
            </ProtectedRoute>
          }
        >
        </Route>
        <Route
          path="/admin/live"
          element={
            <ProtectedRoute>
              <Live/>
            </ProtectedRoute>
          }
        >
        </Route>
        <Route
          path="/admin/running"
          element={
            <ProtectedRoute>
              <Running/>
            </ProtectedRoute>
          }
        >
        </Route>
        <Route
          path="/admin/sectionhero"
          element={
            <ProtectedRoute>
              <SectionHero/>
            </ProtectedRoute>
          }
        >
        </Route>
        <Route
          path="/admin/contactdata"
          element={
            <ProtectedRoute>
              <ContactData/>
            </ProtectedRoute>
          }
        >
        </Route>
        
        <Route path="/p/:slug" element={<ProfileCard />} />  

      </Routes>
      <Footer />
      <LiveWidget />
    </div>
  );
}

export default App;
